import {cs} from "./locales/cs";
import {en} from "./locales/en";
import type {Locale, Messages} from "./types";

export type {Locale, Messages, TranslationKey} from "./types";

const messages: Record<Locale, Messages> = {
    en,
    cs,
};

/**
 * Get current language based on browser settings
 * Defaults to 'en' if browser language is not Czech
 */
export function getLanguage(): Locale {
    const language = navigator.language.split("-")[0];
    return language === "cs" ? "cs" : "en";
}

/**
 * Get messages for current language
 */
export function getMessages(): Messages {
    return messages[getLanguage()];
}
